import React from "react";
import { Button } from "./Button";
import cashboardIcon from "../assets/cashboard-icon.svg";
import excelIcon from "../assets/excel-icon.svg";

interface SignInScreenProps {
  onSignIn: () => void;
}

export function SignInScreen({ onSignIn }: SignInScreenProps) {
  return (
    <div className="flex flex-col h-full" style={{ background: "linear-gradient(180deg, var(--bg2) 0%, var(--bg) 50%, var(--resin-ultralight) 100%)" }}>
      {/* Header — matches TaskPaneHeader position */}
      <div className="flex items-center gap-3 px-4 py-3">
        <img src={cashboardIcon} alt="Cashboard" className="w-7 h-7 flex-shrink-0" />
        <span className="text-base font-medium text-fg font-display-heading">
          Cashboard
        </span>
      </div>

      {/* Centered content */}
      <div className="flex-1 flex flex-col items-center justify-center pb-12">
        {/* Paired icon cards */}
        <div className="flex items-center justify-center mb-8">
          <div className="w-20 h-20 rounded-2xl shadow-lg overflow-hidden animate-fan-left">
            <img src={cashboardIcon} alt="Cashboard" className="w-full h-full" />
          </div>
          <div className="w-20 h-20 rounded-2xl shadow-lg bg-bg-elevated flex items-center justify-center p-3 animate-fan-right">
            <img src={excelIcon} alt="Excel" className="w-full h-full object-contain" style={{ marginLeft: "-3px" }} />
          </div>
        </div>

        <div className="max-w-sm w-full text-center mb-6 px-6">
          <h2 className="text-2xl mb-2 font-normal font-book-heading text-biome">
            Your data, live in Excel
          </h2>

          <p className="text-fg2 text-base leading-relaxed">
            Pull your Cashboard data into Excel and keep it fresh with one click.
          </p>
        </div>

        <div className="max-w-sm w-full px-6">
          <Button variant="primary" size="md" label="Sign in to Cashboard" onClick={onSignIn} className="w-full" />
          <p className="text-fg3 text-sm text-center mt-4">
            Want to sign up? Ask your Cashboard admin for an invite.
          </p>
          <p className="text-sm text-center mt-2">
            <a href="mailto:support@cashboard.co" className="text-fg3 underline hover:text-fg2">Support</a>
          </p>
        </div>
      </div>
    </div>
  );
}
